import { IExportColumnModel } from "../../../../../shared/models";

export const PlanCategoriesColumnList: IExportColumnModel[] = [
]